var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.88209 12.9631C9.89609 12.9821 9.91399 12.9975 9.93442 13.008C9.95485 13.0186 9.97727 13.0241 10 13.0241C10.0227 13.0241 10.0452 13.0186 10.0656 13.008C10.086 12.9975 10.1039 12.9821 10.1179 12.9631L12.2142 10.1452C12.2909 10.0418 12.2217 9.88864 12.0963 9.88864H10.7094V3.15909C10.7094 3.07159 10.642 3 10.5596 3H9.43663C9.35428 3 9.2869 3.07159 9.2869 3.15909V9.88665H7.90374C7.77834 9.88665 7.70909 10.0398 7.78583 10.1432L9.88209 12.9631ZM16.8503 12.267H15.7273C15.6449 12.267 15.5775 12.3386 15.5775 12.4261V15.4886H4.42246V12.4261C4.42246 12.3386 4.35508 12.267 4.27273 12.267H3.14973C3.06738 12.267 3 12.3386 3 12.4261V16.3636C3 16.7156 3.26765 17 3.59893 17H16.4011C16.7324 17 17 16.7156 17 16.3636V12.4261C17 12.3386 16.9326 12.267 16.8503 12.267Z",
    fill: "#606A82"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.d10a6498231fc51d79536627509808cc.svg";
export { ForwardRef as ReactComponent };